/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { Component } from 'react';
// material
import { Icon } from '@insticator/insticator-ui'; // iui-material
// styles
import injectSheet from 'react-jss';
import styles from 'material/embeds/content/edit/delete/delete_styles';



/* ========== ~~~~~~~~~~ EMBED : EDIT : DELETE ~~~~~~~~~~ ========== */
class Delete extends Component {
    constructor(props) {
        super(props);
        this.handleClick = this.handleClick.bind(this);
    }
    handleClick() {
        if (this.props.optionId) {
            this.props.removeOption(this.props.contentId, this.props.optionId);
        } else {
            this.props.deleteContent(this.props.contentId);
        }
    }
    render() {
        if ((this.props.optionId) && (this.props.numberOfOptions < 3)) { return null }
        return (
            <div className={`editorelement delete ${this.props.classes.delete} ${this.props.position}`} onClick={this.handleClick} >
                <Icon name={`trash-alt`} />
            </div>
        );
    }
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(Delete);
